import axios from "axios";
export default {
    state:{
        allitems:[],
        productMostSelledItem:[]
    },
    mutations:{
        setProductos(state,items){
            state.allitems=items
        },
        setProductMostSelledItem(state,data){
            state.productMostSelledItem = data;
        }
    },
    actions:{
        async setProductos({commit,rootState,getters}){           
           await axios.get(`${rootState.urlapi}/articulos`,getters.getTokenUser).then(response=>{
                    commit('setProductos',response.data)  
              }).catch(err=>{console.error(err)});
        },
        async setProductMostSelledItem({commit,rootState,getters}){
            await axios.get(`${rootState.urlapi}/articulos/mostselled`,getters.getTokenUser).then(response=>{
                commit('setProductMostSelledItem',response.data)  
             }).catch(err=>{console.error(err)});
        },
        async decrementStock({rootState,getters},idventa){
           return  await axios.put(`${rootState.urlapi}/articulos/disminuirStock/${idventa}`,{},getters.getTokenUser)
        },
        async updateProducto({rootState,getters},item){
          return   await axios.put(`${rootState.urlapi}/articulos/${item.idarticulo}`,item,getters.getTokenUser)
        }
    },
    getters:{
        getAllProductos(state){
            //Si existe un registro retornamos el arreglo
            if(state.allitems[0])return state.allitems
            //Sino existen registros retornamos un array vacio
            return []
        },
        getProductosActivos(state){
            return state.productMostSelledItem.filter(item=>item.estado=='Activo')
        }
        
    }
}